import { ILookup } from "../shared/form/lookup.model";

export class Lookup implements ILookup {
    id: number | string;
    name: string;
}

export class SelectableLookup extends Lookup {
    selected?: boolean;
}

export class GroupLookup {
    groupName: string;
    items: ILookup[];
}